import {
  ChangeDetectionStrategy,
  Component,
  EventEmitter,
  Input,
  OnChanges,
  Output,
  inject,
} from '@angular/core'
import { Router, RouterLink } from '@angular/router'
import { NavService } from '../../../nav.service'
import { CarrierData } from '../../../api/model/backend.model'
import { MaybeData } from '../../../api/model/api.model'
import { MatDialog } from '@angular/material/dialog'
import { ProgramInitiationMappingDialogComponent } from '../program-initiation-mapping-dialog/program-initiation-mapping-dialog.component'
import { BackendService } from '../../../api/backend/backend.service'
import { AccountMappingData } from '../../model/program-initiation.model'
import { MatIconButton } from '@angular/material/button'
import { MatIcon } from '@angular/material/icon'
import { AppLogoComponent } from '../../../shared/logo/app-logo.component'
import { HeaderTitleComponent } from '../../../shared/header-title.component'

import { ButtonComponent } from '../../../shared/button/button.component'
import { ContactSupportIconContainerComponent } from '../../../shared/contact-support/contact-support-icon-container/contact-support-icon-container.component'

@Component({
  changeDetection: ChangeDetectionStrategy.OnPush,
  selector: 'app-program-initiation-header',
  styleUrls: [`./program-initiation-header.component.scss`],
  templateUrl: `./program-initiation-header.component.html`,
  imports: [
    MatIconButton,
    MatIcon,
    AppLogoComponent,
    RouterLink,
    HeaderTitleComponent,
    ButtonComponent,
    ContactSupportIconContainerComponent,
  ],
})
export class ProgramInitiationHeaderComponent implements OnChanges {
  dialog = inject(MatDialog)
  navService = inject(NavService)
  private router = inject(Router)
  backendService = inject(BackendService)

  @Input() name: string
  /** SF accounts already mapped to a carrier */
  @Input() accountMappings: AccountMappingData[] | null
  @Input() allCarriers: MaybeData<CarrierData[]> | null
  @Output() updateSFMapping = new EventEmitter<AccountMappingData>()

  showSFMappingButton = false

  private carriers: CarrierData[]

  get subtitle(): string {
    return 'Create a new SAGE Program from a Salesforce Opportunity object.'
  }

  ngOnChanges(): void {
    this.carriers = this.allCarriers?.data ?? []
    this.showSFMappingButton = (this.accountMappings?.length ?? 0) >= 1 && this.carriers.length > 0
  }

  onBackClick(): void {
    this.router.navigate(['/home'])
  }

  onSFMappingClick(): void {
    const data = {
      carriers: this.carriers,
      accountMappingData: this.accountMappings ?? [],
    }
    const dialogRef = this.dialog.open(ProgramInitiationMappingDialogComponent, {
      data,
    })
    dialogRef.afterClosed().subscribe((updatedMapping: AccountMappingData) => {
      if (!updatedMapping) {
        return
      }
      this.updateSFMapping.emit(updatedMapping)
    })
  }
}
